import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export default function FloatingCall() {
  return (
    <motion.a
      href="tel:0450454453"
      data-testid="floating-call-button"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.6, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-5 right-5 z-50 flex items-center gap-3"
    >
      <span className="hidden bg-[#0A0C10] px-4 py-2.5 font-display text-sm font-bold uppercase tracking-wider text-white shadow-[0_8px_30px_rgba(0,0,0,0.5)] sm:inline-block">
        Need a pump? Call now
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#0052FF] opacity-40" />
        <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#0052FF] text-white shadow-[0_0_30px_rgba(0,82,255,0.6)] transition-colors duration-300 hover:bg-[#2E74FF]">
          <Phone className="h-6 w-6" />
        </span>
      </span>
    </motion.a>
  );
}